import ReactRailsUJS from 'react_ujs'
import { setReactConstructor } from '../helpers/ViteHelper'
import baseFrontModules from '../helpers/entrypoint_modules/baseFront'

const modules = import.meta.globEager([
  '~/components/cms/docs/case-studies/DocsCaseStudy.{js,jsx,ts,tsx}',
])

const mergedModules = Object.assign(modules, baseFrontModules)

setReactConstructor(ReactRailsUJS, mergedModules)
